import { render } from "./HomeView.vue?vue&type=template&id=f0198a52&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/ch-widget/ch-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__